var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"not-found",attrs:{"aria-labelledby":"not-found-title"}},[_c('p',{staticClass:"status-code"},[_vm._v("404")]),_c('h1',{attrs:{"id":"not-found-title"}},[_vm._v("这个页面不存在")]),_c('p',[_vm._v("链接可能已经失效，或者页面被移动了。")]),_c('router-link',{staticClass:"home-link",attrs:{"to":"/"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }